import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    employees: [],
    mandanten: [],
    loadingEmployees: false,
    loadingMandanten: false,
    creating: false,
    updating: false,
    deleting: false,
    modalOpen: false,
    actionTarget: null,
    errorMessage: null,
};

const userManagementSlice = createSlice({
    name: "userManagement",
    initialState,
    reducers: {
        getEmployeesRequest: (state) => {
            state.loadingEmployees = true;
            state.errorMessage = null;
            state.employees = [];
        },
        getEmployeesSuccess: (state, action) => {
            state.loadingEmployees = false;
            state.employees = action.payload || [];
        },
        getEmployeesFailure: (state, action) => {
            state.loadingEmployees = false;
            state.errorMessage = action.payload;
        },

        getMandantenRequest: (state) => {
            state.loadingMandanten = true;
            state.mandanten = [];
        },
        getMandantenSuccess: (state, action) => {
            state.loadingMandanten = false;
            state.mandanten = action.payload || [];
        },
        getMandantenFailure: (state, action) => {
            state.loadingMandanten = false;
            state.errorMessage = action.payload;
        },

        createEmployeeRequest: (state) => {
            state.creating = true;
            state.errorMessage = null;
        },
        createEmployeeSuccess: (state) => {
            state.creating = false;
        },
        createEmployeeFailure: (state, action) => {
            state.creating = false;
            state.errorMessage = action.payload;
        },

        updateEmployeeRequest: (state) => {
            state.updating = true;
            state.errorMessage = null;
        },
        updateEmployeeSuccess: (state) => {
            state.updating = false;
            state.actionTarget = null;
        },
        updateEmployeeFailure: (state, action) => {
            state.updating = false;
            state.errorMessage = action.payload;
        },

        deleteEmployeeRequest: (state) => {
            state.deleting = true;
            state.errorMessage = null;
        },
        deleteEmployeeSuccess: (state) => {
            state.deleting = false;
            state.actionTarget = null;
        },
        deleteEmployeeFailure: (state, action) => {
            state.deleting = false;
            state.errorMessage = action.payload;
        },

        openActionsModal: (state, action) => {
            state.actionTarget = action.payload;
            state.errorMessage = null;
        },
        closeActionsModal: (state) => {
            state.actionTarget = null;
            state.errorMessage = null;
        },

        toggleModal: (state, action) => {
            state.modalOpen = action.payload !== undefined ? action.payload : !state.modalOpen;
            state.errorMessage = null;
        },
        clearError: (state) => {
            state.errorMessage = null;
        },
    },
});

export default userManagementSlice;
